import {
  AccessTimeOutlined as AccessTimeOutlinedIcon,
  AccountBalanceWalletOutlined as AccountBalanceWalletOutlinedIcon,
  AccountTree as AccountTreeIcon,
  AccountTreeOutlined as AccountTreeOutlinedIcon,
  AddCircleOutlined as AddCircleOutlineIcon,
  Analytics as AnalyticsIcon,
  Animation as AnimationIcon,
  Article as ArticleIcon,
  AssignmentTurnedIn as AssignmentTurnedInIcon,
  BatchPredictionOutlined as BatchPredictionOutlinedIcon,
  BeenhereOutlined as BeenhereOutlinedIcon,
  CalendarViewWeek as CalendarViewWeekIcon,
  Category as CategoryIcon,
  Checklist as ChecklistIcon,
  CopyAllOutlined as CopyAllOutlinedIcon,
  CropOriginal as CropOriginalIcon,
  DeviceThermostatOutlined as DeviceThermostatOutlinedIcon,
  DocumentScannerOutlined as DocumentScannerOutlinedIcon,
  EditLocationAlt as EditLocationAltIcon,
  Error as ErrorIcon,
  Feed as FeedIcon,
  FilterAltOutlined as FilterAltOutlinedIcon,
  FingerprintOutlined as FingerprintOutlinedIcon,
  Flight as FlightIcon,
  FormatShapes as FormatShapesIcon,
  Help as HelpIcon,
  HowToReg as HowToRegIcon,
  ImportantDevicesOutlined as ImportantDevicesOutlinedIcon,
  Key as KeyIcon,
  Lightbulb as LightbulbIcon,
  List as ListIcon,
  LocalAtm as LocalAtmIcon,
  LocalOffer as LocalOfferIcon,
  LocalShipping as LocalShippingIcon,
  LocationOn as LocationOnIcon,
  ManageAccounts as ManageAccountsIcon,
  Map as MapIcon,
  MarkEmailUnreadOutlined as MarkEmailUnreadOutlinedIcon,
  Merge as MergeIcon,
  MonetizationOn as MonetizationOnIcon,
  MonetizationOnOutlined as MonetizationOnOutlinedIcon,
  NearbyError as NearbyErrorIcon,
  NotificationsActiveOutlined as NotificationsActiveOutlinedIcon,
  Payments as PaymentsIcon,
  PermPhoneMsg as PermPhoneMsgIcon,
  Person as PersonIcon,
  PersonOffOutlined as PersonOffOutlinedIcon,
  PersonPinCircle as PersonPinCircleIcon,
  PersonPinCircleOutlined as PersonPinCircleOutlinedIcon,
  PhoneIphone as PhoneIphoneIcon,
  PlaceOutlined as PlaceOutlinedIcon,
  PriceCheck as PriceCheckIcon,
  PublicOutlined as PublicOutlinedIcon,
  QueryStatsOutlined as QueryStatsOutlinedIcon,
  QuestionAnswer as QuestionAnswerIcon,
  QuestionAnswerOutlined as QuestionAnswerOutlinedIcon,
  RateReview as RateReviewIcon,
  ReceiptLongOutlined as ReceiptLongOutlinedIcon,
  RecordVoiceOverOutlined as RecordVoiceOverOutlinedIcon,
  RequestQuoteOutlined as RequestQuoteOutlinedIcon,
  Rocket as RocketIcon,
  RouteOutlined as RouteOutlinedIcon,
  ScatterPlot as ScatterPlotIcon,
  SensorOccupied as SensorOccupiedIcon,
  Shelves as ShelvesIcon,
  ShowChartOutlined as ShowChartOutlinedIcon,
  SpeedOutlined as SpeedOutlinedIcon,
  Style as StyleIcon,
  SupportAgentOutlined as SupportAgentOutlinedIcon,
  UpdateOutlined as UpdateOutlinedIcon,
  WebStoriesOutlined as WebStoriesOutlinedIcon,
  Work as WorkIcon,
} from "@mui/icons-material";

import { ACL } from "@/modules/auth/Auth";

import { SidebarLinkProps } from "./SidebarLink";

export type MenuItem = {
  label: string;
  to: string;
  icon: React.ReactElement;
  nested?: Record<ACL, MenuItem> | SidebarLinkProps[];
  selected?: boolean;
};

const MENU_ITEMS: Record<ACL, MenuItem> = {
  dashboard: {
    label: "Dashboard",
    to: "/dashboard",
    icon: <SpeedOutlinedIcon />,
  },
  customers: {
    label: "Customers",
    to: "/customers",
    icon: <PersonIcon />,
  },
  sac: {
    label: "Missions (sac)",
    to: "/sac",
    icon: <FlightIcon />,
  },
  missions: {
    label: "Missions",
    icon: <RocketIcon />,
    to: "/missions",
    nested: {
      "missions>list": {
        label: "List",
        to: "/missions",
        icon: <ListIcon />,
      },
      "missions>create": {
        label: "Create",
        to: "/missions/new",
        icon: <AddCircleOutlineIcon />,
        nested: {
          "missions>create>virtual": {
            label: "Virtual",
            to: "/missions/new/virtual",
            icon: <PhoneIphoneIcon />,
          },
          "missions>create>geo": {
            label: "Geo",
            to: "/missions/new/geo",
            icon: <PlaceOutlinedIcon />,
          },
          "missions>create>explorer": {
            label: "Explorer",
            to: "/missions/new/explorer",
            icon: <MapIcon />,
          },
        },
      },
    },
  },
  projects: {
    label: "Projects",
    to: "/projects",
    icon: <WorkIcon />,
    nested: {
      "projects>list": {
        label: "List",
        to: "/projects",
        icon: <ListIcon />,
      },
      "projects>create": {
        label: "Create",
        to: "/projects/audit",
        icon: <AddCircleOutlineIcon />,
        nested: {
          "projects>create>audit": {
            label: "Audit",
            to: "/audit/new",
            icon: <BeenhereOutlinedIcon />,
          },
          "projects>create>tree": {
            label: "Decision Tree",
            to: "/projects/tree",
            icon: <AccountTreeOutlinedIcon />,
          },
          "projects>create>other": {
            label: "Other",
            to: "/projects/new",
            icon: <WorkIcon />,
          },
        },
      },
    },
  },
  surveys: {
    label: "Surveys",
    to: "/surveys",
    icon: <ShelvesIcon />,
    nested: {
      "surveys>list": {
        label: "List",
        to: "/surveys",
        icon: <ListIcon />,
      },
      "surveys>create": {
        label: "Create",
        to: "/surveys/new",
        icon: <AddCircleOutlineIcon />,
      },
    },
  },
  agents: {
    label: "Agents",
    to: "/agents",
    icon: <HowToRegIcon />,
    nested: {
      "agents>statistics": {
        label: "Statistics",
        to: "/agents/statistics",
        icon: <ShowChartOutlinedIcon />,
      },
    },
  },
  bespoke: {
    label: "Bespoke Solutions",
    to: "/",
    icon: <AnimationIcon />,
    nested: {
      "bespoke>uber>pricing": {
        label: "Uber Pricing",
        to: "/",
        icon: <PriceCheckIcon />,
        nested: {
          "bespoke>uber>pricing>routes": {
            label: "Routes",
            to: "/spuber/routes",
            icon: <RouteOutlinedIcon />,
          },
          "bespoke>uber>pricing>review": {
            label: "Reviews",
            to: "/spuber/routes/review",
            icon: <RateReviewIcon />,
          },
          "bespoke>uber>pricing>batches": {
            label: "Batches",
            to: "/spuber/batches",
            icon: <BatchPredictionOutlinedIcon />,
          },
          "bespoke>uber>pricing>dashboard": {
            label: "Dashboard",
            to: "/spuber/delivery/dashboard",
            icon: <CalendarViewWeekIcon />,
          },
        },
      },
      "bespoke>uber>structural": {
        label: "Uber Structural",
        to: "/",
        icon: <AccountTreeIcon />,
        nested: {
          "bespoke>uber>structural>answers": {
            label: "Synchronizer",
            to: "/spuber/structural",
            icon: <ChecklistIcon />,
          },
        },
      },
    },
  },
  courier: {
    label: "Courier",
    to: "/courier/simulator",
    icon: <LocalShippingIcon />,
  },
  locations: {
    label: "Locations",
    to: "/locations",
    icon: <LocationOnIcon />,
    nested: {
      "locations>regions": {
        label: "Regions",
        to: "/locations/regions",
        icon: <EditLocationAltIcon />,
      },
      "locations>explorer": {
        label: "Explorer Polygons",
        to: "/locations/explorer",
        icon: <FormatShapesIcon />,
      },
    },
  },
  answers: {
    label: "Answers",
    to: "/answers",
    icon: <QuestionAnswerIcon />,
    nested: {
      "answers>list": {
        label: "List",
        to: "/answers",
        icon: <ListIcon />,
      },
      "answers>queue": {
        label: "Queue",
        to: "/answers/queue",
        icon: <WebStoriesOutlinedIcon />,
      },
      "answers>approval": {
        label: "Approval",
        to: "/answers/approval",
        icon: <WebStoriesOutlinedIcon />,
      },
    },
  },
  merges: {
    label: "Merges",
    to: "/merges",
    icon: <MergeIcon />,
  },
  qre: {
    label: "QREs",
    to: "/qre",
    icon: <FeedIcon />,
    nested: {
      "qre>list": {
        label: "List",
        to: "/qre",
        icon: <ListIcon />,
      },
      "qre>create": {
        label: "Create",
        to: "/qre/new",
        icon: <AddCircleOutlineIcon />,
      },
    },
  },
  qde: {
    label: "QDEs",
    to: "/qde",
    icon: <CropOriginalIcon />,
    nested: {
      "qde>list": {
        label: "List",
        to: "/qde",
        icon: <ListIcon />,
      },
      "qde>create": {
        label: "Create",
        to: "/qde/new",
        icon: <AddCircleOutlineIcon />,
      },
    },
  },
  beacons: {
    label: "Beacons",
    to: "/beacons",
    icon: <LightbulbIcon />,
    nested: {
      "beacons>list": {
        label: "List",
        to: "/beacons",
        icon: <ListIcon />,
      },
      "beacons>create": {
        label: "Create",
        to: "/beacons/new",
        icon: <AddCircleOutlineIcon />,
      },
      "beacons>tags": {
        label: "Tags",
        to: "/beacons/tags",
        icon: <StyleIcon />,
      },
    },
  },
  users: {
    label: "Opiners",
    to: "/users",
    icon: <PersonPinCircleIcon />,
    nested: {
      "users>list": {
        label: "List",
        to: "/users",
        icon: <ListIcon />,
      },
      "users>frauds": {
        label: "Frauds",
        to: "/users/frauds",
        icon: <NearbyErrorIcon />,
      },
      "users>queue": {
        label: "VRFDocs Queue",
        to: "/users/queue",
        icon: <FingerprintOutlinedIcon />,
      },
      "users>filters": {
        label: "Filter Simulator",
        to: "/users/filters",
        icon: <FilterAltOutlinedIcon />,
      },
      "users>active_users": {
        label: "Active Users",
        to: "/users/active_users",
        icon: <RecordVoiceOverOutlinedIcon />,
      },
      "users>balance": {
        label: "Balance",
        to: "/users/balance",
        icon: <AccountBalanceWalletOutlinedIcon />,
      },
      "users>activity": {
        label: "Activity",
        to: "/users/activity",
        icon: <AccessTimeOutlinedIcon />,
      },
    },
  },
  cashflow: {
    label: "Cashflow",
    to: "/cash",
    icon: <MonetizationOnIcon />,
  },
  withdrawals: {
    label: "Withdrawals",
    to: "/withdrawals",
    icon: <PaymentsIcon />,
    nested: {
      "withdrawals>list": {
        label: "List",
        to: "/withdrawals",
        icon: <ListIcon />,
      },
      "withdrawals>dashboard": {
        label: "Dashboard",
        to: "/withdrawals/dashboard",
        icon: <CalendarViewWeekIcon />,
      },
      "withdrawals>approval": {
        label: "Approval Queue",
        to: "/withdrawals/approval",
        icon: <LocalAtmIcon />,
      },
      "withdrawals>errors": {
        label: "Broker Errors",
        to: "/withdrawals/errors",
        icon: <ErrorIcon />,
      },
    },
  },
  ceu: {
    label: "CEU",
    to: "/ceu",
    icon: <SensorOccupiedIcon />,
  },
  comm: {
    label: "Comm Center",
    to: "/comm",
    icon: <PermPhoneMsgIcon />,
    nested: {
      "comm>push-to-dev": {
        label: "Push to dev devices",
        to: "/dev/push",
        icon: <ImportantDevicesOutlinedIcon />,
      },
      "comm>push": {
        label: "Broadcast Push",
        to: "/comm/push",
        icon: <NotificationsActiveOutlinedIcon />,
        nested: {
          "comm>push>list": {
            label: "List",
            to: "/comm/push/list",
            icon: <ListIcon />,
          },
          "comm>push>create": {
            label: "Create",
            to: "/comm/push/create",
            icon: <AddCircleOutlineIcon />,
          },
        },
      },
      "comm>email": {
        label: "Email",
        to: "/comm/email",
        icon: <MarkEmailUnreadOutlinedIcon />,
        nested: {
          "comm>email>list": {
            label: "List",
            to: "/comm/email",
            icon: <ListIcon />,
          },
          "comm>email>create": {
            label: "Create",
            to: "/comm/new_email",
            icon: <AddCircleOutlineIcon />,
          },
          "comm>email>templates": {
            label: "Templates",
            to: "/comm/templates",
            icon: <CopyAllOutlinedIcon />,
          },
        },
      },
    },
  },
  analytics: {
    label: "Analytics",
    to: "/analytics",
    icon: <AnalyticsIcon />,
    nested: {
      "analytics>overview": {
        label: "Overview",
        to: "/analytics",
        icon: <QueryStatsOutlinedIcon />,
      },
      "analytics>dashboards": {
        label: "Dashboards",
        to: "/",
        icon: <AccountTreeOutlinedIcon />,
        nested: {
          "analytics>dashboards>flex": {
            label: "Flexviews",
            to: "/analytics/flex",
            icon: <QueryStatsOutlinedIcon />,
          },
        },
      },
      "analytics>map": {
        label: "Map",
        to: "/map",
        icon: <PublicOutlinedIcon />,
      },
      "analytics>heatmap": {
        label: "Heat Map",
        to: "/analytics/heatmap",
        icon: <DeviceThermostatOutlinedIcon />,
      },
      "analytics>users-per-region": {
        label: "Users per Region",
        to: "/dx/user_region",
        icon: <PersonPinCircleOutlinedIcon />,
      },
      "analytics>users-on-latest": {
        label: "Users on Latest",
        to: "/dx/users_latest",
        icon: <UpdateOutlinedIcon />,
      },
      "analytics>answers": {
        label: "Answers",
        to: "/analytics/answers",
        icon: <QuestionAnswerOutlinedIcon />,
      },
      "analytics>blocked-opiners": {
        label: "Blocked Opiners",
        to: "/analytics/blocked_users",
        icon: <PersonOffOutlinedIcon />,
      },
      "analytics>monitoring-agents-vrf": {
        label: "Monitoring Agents VRF",
        to: "/analytics/monitoring_agents_vrf",
        icon: <DocumentScannerOutlinedIcon />,
      },
      "analytics>cashflow": {
        label: "Cashflow",
        to: "/analytics/cahflow",
        icon: <MonetizationOnOutlinedIcon />,
      },
      "analytics>expenses": {
        label: "Expenses",
        to: "/analytics/expenses",
        icon: <RequestQuoteOutlinedIcon />,
      },
      "analytics>aac_efficiency": {
        label: "AAC Efficiency",
        to: "/analytics/aac_efficiency",
        icon: <RequestQuoteOutlinedIcon />,
      },
    },
  },
  reports: {
    label: "Reports",
    to: "/reports",
    icon: <ReceiptLongOutlinedIcon />,
  },
  ausers: {
    label: "Permissions",
    icon: <KeyIcon />,
    to: "/ausers",
    nested: {
      "ausers>list": {
        label: "Admin Users",
        to: "/ausers",
        icon: <ManageAccountsIcon />,
      },
      "ausers>templates>list": {
        label: "Templates",
        to: "/ausers/templates",
        icon: <KeyIcon />,
      },
    },
  },
  pdp: {
    label: "Profile Data Points",
    to: "/pdp",
    icon: <ScatterPlotIcon />,
    nested: {
      "pdp>list": {
        label: "List",
        to: "/pdp",
        icon: <ListIcon />,
      },
      "pdp>create": {
        label: "Create",
        to: "/pdp/new",
        icon: <AddCircleOutlineIcon />,
      },
    },
  },
  faq: {
    label: "FAQ",
    to: "/faq",
    icon: <HelpIcon />,
    nested: {
      "faq>articles": {
        label: "Articles",
        to: "/faq/articles",
        icon: <ArticleIcon />,
      },
      "faq>tags": {
        label: "Tags",
        to: "/faq/tags",
        icon: <LocalOfferIcon />,
      },
      "faq>categories": {
        label: "Categories",
        to: "/faq/categories",
        icon: <CategoryIcon />,
      },
    },
  },
  tasks: {
    label: "Tasks",
    to: "/tasks",
    icon: <AssignmentTurnedInIcon />,
  },
  support: {
    label: "Support",
    to: "/support/tickets",
    icon: <SupportAgentOutlinedIcon />,
  },
} as Record<ACL, MenuItem>;

function getMenuItem(
  menuItem: Record<ACL, MenuItem> | SidebarLinkProps[],
  permissions: ACL[]
): SidebarLinkProps[] {
  if (Array.isArray(menuItem)) {
    return menuItem;
  }

  const menuItems: SidebarLinkProps[] = [];

  (Object.keys(menuItem) as ACL[]).forEach((acl) => {
    if (!permissions.includes(acl)) {
      return;
    }

    const item: SidebarLinkProps = {
      label: menuItem[acl].label,
      to: menuItem[acl].to,
      icon: menuItem[acl].icon || <span />,
      selected: menuItem[acl].selected,
    };

    const nested = menuItem[acl].nested;
    if (nested) {
      item["nested"] = getMenuItem(nested, permissions);
    }

    menuItems.push(item);
  });

  return menuItems;
}

interface NestedItem {
  label?: string;
  to?: string;
  icon?: JSX.Element | null;
  nested?: Record<string, NestedItem> | NestedItem[];
}

export interface FlattenedItem {
  searchable?: string;
  label: string;
  type: "Pages" | "Global Search" | string;
  to?: string;
  search?: string;
  disabled?: boolean;
  icon: JSX.Element | null;
}

function flatmapHelper(
  obj: Record<string, NestedItem>,
  permissions: string[]
): FlattenedItem[] {
  function flatten(
    obj: Record<string, NestedItem> | NestedItem[],
    parentLabel = ""
  ): FlattenedItem[] {
    const result: FlattenedItem[] = [];

    Object.keys(obj).forEach((key) => {
      const isArrayChild = !isNaN(parseFloat(key));
      if (isArrayChild || !permissions.includes(key)) {
        return;
      }
      const item: NestedItem = (obj as Record<string, NestedItem>)[key];
      const newLabel = parentLabel
        ? `${parentLabel} > ${item.label}`
        : item.label || key.replace(/^[a-z]/, (c) => c.toUpperCase());

      if (item.nested) {
        result.push(...flatten(item.nested, newLabel));
      } else {
        key = key.split(">").reverse().join(" ");

        const newItem: FlattenedItem = {
          searchable: `${item.to?.substring(1)} ${key}`,
          label: newLabel.trim(),
          to: item.to || "",
          type: "Pages",
          icon: item.icon || null,
        };
        result.push(newItem);
      }
    });

    return result;
  }

  return flatten(obj);
}

export const getMenuForSearch = (permissions: ACL[]): FlattenedItem[] =>
  flatmapHelper(MENU_ITEMS, permissions);

export default function getMenu(permissions: ACL[]): SidebarLinkProps[] {
  return getMenuItem(MENU_ITEMS, permissions);
}
